import React, { useEffect, cloneElement, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setMathJaxAction } from "../../../../redux/mathjax";
import { splitQuestionAction } from "../../../../redux/answeringQuestions/answeringQuestions";

const GrammarReducer = ( props ) => {

  const mathjax = useSelector( state => state.mathjax );
  const answeringQuestions = useSelector( state => state.answeringQuestions );

  const dispatch = useDispatch();
  const setMathJax = payload => { dispatch( setMathJaxAction( payload ) ) };
  const splitQuestion = payload => { dispatch( splitQuestionAction( payload ) ) };

  useEffect( () => {
    answeringQuestions.data.qstCd && splitQuestion( answeringQuestions.data.qstCn );
  }, [ answeringQuestions.data.qstCd ] );

  const renderMathJax = ( name, renderKey ) => {
    setMathJax( { renderKey : { ...mathjax.renderKey, [ name ] : renderKey } } );
  };

  return cloneElement( props.children || <Fragment />, { onRenderMathJax : renderMathJax } );

};

export default GrammarReducer;
